module.exports = __webpack_public_path__ + "img/ellipse.dcd14d1f.svg";